import React, { useContext } from 'react';
import styled, { keyframes, ThemeContext } from 'styled-components';
import Typography from '../atoms/Typography';

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 4px solid rgba(0, 169, 255, 0.1);
  border-top: 4px solid ${props => props.theme.colors.brand.primary};
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${rotate} 1s linear infinite;
`;

const LoadingOverlay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
  gap: 16px;
`;

const Page = ({ title, subtitle, headerAction, loading, children, ...props }) => {
  const theme = useContext(ThemeContext);
  return (
    <div className="container-fluid py-4" {...props}>
      {(title || subtitle || headerAction) && (
        <div className="row mb-4">
          <div className="col-12 py-3 border-bottom" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              {title && (
                <Typography variant="articleTitle" style={{ color: theme.colors.brand.primary, marginBottom: subtitle ? '4px' : '0' }}>
                  {title}
                </Typography>
              )}
              {subtitle && (
                <Typography variant="paragraph" style={{ color: theme.colors.text.secondary, display: 'block' }}>
                  {subtitle}
                </Typography>
              )}
            </div>
            {headerAction && (
              <div>
                {headerAction}
              </div>
            )}
          </div>
        </div>
      )}
      {loading ? (
        <LoadingOverlay>
          <Spinner />
          <Typography size="sm" style={{ color: theme.colors.text.secondary }}>Carregando...</Typography>
        </LoadingOverlay>
      ) : (
        children
      )}
    </div>
  );
};

export default Page;



// WEBPACK FOOTER //
// ./src/design-system/layout/Page.jsx